import { getSiteUrl } from "@repo/shared"
import Image from "next/image"

interface Iprops {
  logo: {
    href: string
    src: string
  }
  locale: string
}
const Logo: React.FC<Iprops> = ({ logo, locale }) => {
  return (
    <a href={`${getSiteUrl("www")}/${locale}${logo.href}`} className="logoLink">
      <Image src={logo.src} alt="logo" width={96} height={40} />
    </a>
  )
}
export default Logo
